import React from 'react';
import { Group, Skeleton } from '@landr/maestro';
import { FilterGroup } from '../style';

const SkeletonHeights = [
    200, 400, 250, 125, 350, 280, 125, 410, 300, 250, 210, 280,
];

export const FilterSkeleton = () => (
    <>
        {SkeletonHeights.map((height) => (
            <FilterGroup direction="vertical" gutter="xs">
                <Group.Item>
                    <Skeleton width="100%" height="28px" />
                </Group.Item>
                <Group.Item>
                    <Skeleton width="100%" height={`${height}px`} />
                </Group.Item>
            </FilterGroup>
        ))}
    </>
);
